import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/shared/interfaces/user.interface';
import { MembersService } from 'src/app/members/members.service';
import { LoaderService } from 'src/app/components/loader/service/loader.service';

@Component({
  selector: 'app-permissions-rules',
  templateUrl: './permissions-rules.component.html',
  styleUrls: ['./permissions-rules.component.css'],
})
export class PermissionsRulesComponent implements OnInit {
  searchValue = '';
  members: User[] = [];
  showLoader: boolean = false;
  paginate = {
    page: 1,
    limit: 10,
    lastPage: null,
  };

  constructor(
    private memberService: MembersService,
    private loadService: LoaderService
  ) {}

  ngOnInit() {
    this.getMembers(this.paginate);
  }

  onScroll(event: any) {
    const tracker = event.target;
    const limit = tracker.scrollHeight - tracker.clientHeight;
    
    // Se o usuário rolou até o fim da lista (com uma pequena margem de erro)
    if (tracker.scrollTop >= limit - 10 && this.members.length !== 0 && this.paginate.page < this.paginate.lastPage) {
      if (!this.showLoader) {
        this.paginate.page++;
        this.getMembers(this.paginate);
      }
    }
  }

  loadMore() {
    if (this.paginate.page < this.paginate.lastPage) {
      this.paginate.page++;
      this.getMembers(this.paginate);
    }
  }

  getMembers(paginate: any): void {
    this.showLoader = true;
    this.memberService
      .get(paginate)
      .then((res) => {
        this.showLoader = false;
        this.members = this.members.concat(res.data);
        this.paginate.lastPage = res?.lastPage;
      })
      .catch((err) => {
        this.showLoader = false;
      });
  }

  search($val: string) {
    this.showLoader = true;
    this.memberService.searchMember($val).then((res) => {
      this.members = res;
      this.showLoader = false;
    });
  }
}
